<template>
  <div v-show="visible" ref="leTpLineInfo" class="le-tp-line-info" data-position-param="right" :style="boxPosition" @mouseenter="handleMouseEnterEvent" @mouseleave="handleMouseLeaveEvent">
    <div class="le-tp-line-body">
      <div class="le-tp-line-con">
        <el-table class="le-table" :data="tableParams.tableData" :stripe="true" border max-height="300">
          <el-table-column prop="dataLabel" label="属性" min-width="200" />
          <el-table-column prop="dataValue" label="值" min-width="200" />

          <template slot="empty">
            <el-empty description="暂无数据" />
          </template>
        </el-table>
      </div>

      <div class="le-tp-line-arrow" :style="arrowPosition" />
    </div>
  </div>
</template>

<script>
import {getShapeSize} from '../../scripts/core/logic/node';
import {listLineDetailById, tableParams} from '../../scripts/data';

export default {
  name: 'LeTpLineInfo',
  data() {
    return {
      visible: false,
      shapeId: '',
      offset: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      tableParams: {...tableParams}
    };
  },
  computed: {
    boxPosition() {
      return {
        top: (this.offset.y - 120) + 'px',
        left: (this.offset.x + 20) + 'px'
      };
    },
    arrowPosition() {
      return {
        top: (this.offset.y - 6) + 'px',
        left: (this.offset.x + 24) + 'px'
      };
    }
  },
  watch: {
    shapeId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadLineDetailById(newVal);
        }
      },
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      this.initGlobalEvent();
    });
  },
  destroyed() {
    // 销毁自定义全局事件
    this.$bus.$off();
  },
  methods: {
    initGlobalEvent() {
      // 显示连线信息
      this.$bus.$on('custom:edge:info:showDetail', (status, item, point) => {

        clearTimeout(window.tpLineInfoSetTimeout);
        window.tpLineInfoSetTimeout = setTimeout(() => {
          this.visible = status;
          this.shapeId = item?.getModel()?.id;

          const sizeAttr = getShapeSize(item);
          this.offset = {
            x: point?.x || 0,
            y: point?.y || 0,
            width: sizeAttr.width,
            height: sizeAttr.height
          };
        }, status ? 1000 : 200);
      });

    },
    loadLineDetailById() {
      listLineDetailById(this.shapeId).then(resp => {
        this.tableParams.tableData = resp?.data;
      });
    },
    handleMouseEnterEvent() {
      clearTimeout(window.tpLineInfoSetTimeout);
      this.visible = true;
    },
    handleMouseLeaveEvent() {
      clearTimeout(window.tpLineInfoSetTimeout);
      this.visible = false;
    }
  }
};
</script>

<style scoped>

</style>
